import { Component, OnInit, DestroyRef, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import dayjs from "dayjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

// Services
import { MsalService } from "@azure/msal-angular";
import { StoreUserService } from '@app/core/state/store-user.service';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { UpdateSectionGroupAdminService } from "../../../data/section-group/update-section-group-admin.service";
import { InviteMembersService } from "../../../data/member/invite-members.service";
import { CreateSectionGroupAdminService } from "../../../data/section-group/create-section-group-admin.service";
import {
  resetFormUntouched,
  revalidateForm,
  clearValidatorsExcept,
} from "../../../utils";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { DISTRIBUTOR_AGENT_I18N } from "./distributor-agent-invite.i18n";

@Component({
  selector: "app-distributor-agent-invite",
  templateUrl: "./distributor-agent-invite.component.html",
  styleUrls: ["./distributor-agent-invite.component.css"],
  imports: SHARED_IMPORTS,
})
export class DistributorAgentInviteComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = DISTRIBUTOR_AGENT_I18N;

  // public validId: boolean = false;
  // public primaryAccount: boolean = false;

  // public mode = SectionGroupAdminDetailMode.disp;
  // Mode = SectionGroupAdminDetailMode;

  distributorAgentFormGroup: FormGroup;

  // private readonly defaultAdminData: AdminData = {
  //   userId: "",
  //   sectionGroupId: "",

  //   signInName: "",
  //   password: "",
  //   email: "",

  //   birthDate: "",
  //   sex: "",

  //   lastName: "",
  //   firstName: "",
  //   name: "",

  //   roles: [],

  //   status: "",

  //   assignedDate: "--/--/--",

  //   lastModifiedAt: "--/--/--",
  //   lastModifiedBy: "--",
  // };

  // accountStatus = [
  //   { value: "OPEN", viewValue: this.i18n.status.active },
  //   { value: "CLOSE", viewValue: this.i18n.status.inactive },
  // ];

  // sexOptions = [
  //   { display: this.i18n.sex.male, value: "male" },
  //   { display: this.i18n.sex.female, value: "female" },
  //   { display: this.i18n.sex.other, value: "other" },
  // ];

  // selectedStatus = "";
  distributorId;
  // selectedRole = [];
  // selectedPrivileges = [];

  // accountManageRole = false;
  // userManageRole = false;
  // measureRole = false;
  // referRole = false;

  // adminData: AdminData;
  loginUserId: string;

  // changesMade = false;

  constructor(
    public dialogRef: MatDialogRef<DistributorAgentInviteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _matdialog: MatDialog,
    public storeUser: StoreUserService,
    public storeAuth: StoreAuthService,
    private msalService: MsalService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
    public common: DatabaseCacheService,
    private inviteMembersService: InviteMembersService,
  ) {}

  ngOnInit() {
    // this.adminData = this.data?.adminData ?? this.defaultAdminData;
    // this.mode = this.data?.mode;
    this.distributorId = this.data?.distributorId;
    // this.resetFields();

    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        let user = this.msalService.instance.getActiveAccount();
        this.loginUserId = user.idTokenClaims["sub"];
      });

    // 入力フォームのフィールド定義
    this.distributorAgentFormGroup = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.email]),
    });

    // // 入力フォームのフィールド定義
    // this.adminFormGroup = new FormGroup({
    //   email: new FormControl(''),

    //   lastName: new FormControl(''),
    //   firstName: new FormControl(''),
    //   userId : new FormControl(''),

    //   signInName: new FormControl(''),
    //   password: new FormControl(''),
    //   password_confirm: new FormControl(''),

    //   birthDate: new FormControl(''),
    //   sex: new FormControl(''),

    //   assignedData : new FormControl(''),

    //   status : new FormControl(''),
    // });

    // this.common.sectionGroupAdminRoles.forEach((role) =>
    //   this.distributorAgentFormGroup.addControl(role.code, new FormControl(false)),
    // ); // 各roleに対してコントロールを追加

    // this.distributorAgentFormGroup.disable();

    // if (
    //   this.mode == SectionGroupAdminDetailMode.invite ||
    //   this.mode == SectionGroupAdminDetailMode.create
    // ) {
    //   this.enableInput();
    // } else if (
    //   this.mode == SectionGroupAdminDetailMode.disp ||
    //   this.mode == SectionGroupAdminDetailMode.edit
    // ) {
    //   // 表示データ割り当て
    //   this.distributorAgentFormGroup.patchValue(this.adminData, { emitEvent: false });
    //   this.adminData.roles?.forEach((r) => {
    //     this.distributorAgentFormGroup.get(r)?.setValue(true, { emitEvent: false });
    //   });
    // }

    resetFormUntouched(this.distributorAgentFormGroup);

    //
    // this.route.params
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((params) => {
    //     // this.userId = this.data?.id;
    //     // this.sectionId = this.common.getSelectedSection().sectionId;
    //     // this.getStaff();
    //   });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // switchToEditMode() {
  //   this.mode = SectionGroupAdminDetailMode.edit;

  //   this.enableInput();

  //   return;
  // }

  // enableInput() {
  //   this.adminFormGroup.get("signInName").enable();
  //   this.adminFormGroup.get("password").enable();
  //   this.adminFormGroup.get("password_confirm").enable();

  //   this.adminFormGroup.get("email").enable();

  //   this.adminFormGroup.get("birthDate").enable();
  //   this.adminFormGroup.get("sex").enable();

  //   if (this.mode == this.Mode.create) {
  //     this.adminFormGroup.get("firstName").enable();
  //     this.adminFormGroup.get("lastName").enable();
  //   }

  //   if (this.loginUserId != this.adminData.userId) {
  //     //自分自身のステータスと権限は変更できない。
  //     this.adminFormGroup.get("status").enable();

  //     this.common.sectionGroupAdminRoles.forEach((r) => {
  //       this.adminFormGroup.get(r.code).enable();
  //     });
  //   }

  //   this.adminFormGroup.valueChanges
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe(() => {
  //       this.changesMade = true;
  //     });

  //   return;
  // }

  onEditOrUploadClicked() {

    {
      // // 現在がディスプレイモードなら編集モードに切り替える
      // if (this.mode == SectionGroupAdminDetailMode.disp) {
      //   this.switchToEditMode();
      //   return;
      // }

      // if (this.mode == SectionGroupAdminDetailMode.edit) {
      //   // firstName,   lastName だけが必須
      //   clearValidatorsExcept(this.distributorAgentFormGroup, ["firstName", "lastName"]);
      //   // this.adminFormGroup.get('email')?.clearValidators();
      //   // // this.adminFormGroup.get('firstName')?.clearValidators();
      //   // // this.adminFormGroup.get('lastName')?.clearValidators();
      //   // this.adminFormGroup.get('birthDate')?.clearValidators();
      //   // this.adminFormGroup.get('signInName')?.clearValidators();
      //   // this.adminFormGroup.get('password')?.clearValidators();
      //   // this.adminFormGroup.get('password_confirm')?.clearValidators();
      // }

      // if (this.mode == SectionGroupAdminDetailMode.invite) {
      //   // email だけが必須
      //   clearValidatorsExcept(this.distributorAgentFormGroup, ["email"]);

      //   // // this.adminFormGroup.get('email')?.clearValidators();
      //   // this.adminFormGroup.get('firstName')?.clearValidators();
      //   // this.adminFormGroup.get('lastName')?.clearValidators();
      //   // this.adminFormGroup.get('birthDate')?.clearValidators();
      //   // this.adminFormGroup.get('signInName')?.clearValidators();
      //   // this.adminFormGroup.get('password')?.clearValidators();
      //   // this.adminFormGroup.get('password_confirm')?.clearValidators();
      // }

      // // if (this.mode == SectionGroupAdminDetailMode.create) {
      // //   // Do Nothing
      // //   // すべてのフィールドが必須なので、clearValidatorsExcept()はしない
      // //   // this.adminFormGroup.get('email')?.clearValidators();
      // //   // this.adminFormGroup.get('firstName')?.clearValidators();
      // //   // this.adminFormGroup.get('lastName')?.clearValidators();
      // //   // this.adminFormGroup.get('birthDate')?.clearValidators();
      // //   // this.adminFormGroup.get('signInName')?.clearValidators();
      // //   // this.adminFormGroup.get('password')?.clearValidators();
      // //   // this.adminFormGroup.get('password_confirm')?.clearValidators();
      // // }

      // revalidateForm(this.distributorAgentFormGroup); // 現在のValidatorRuleを使ってValidationをやりなおす
      // // Object.keys(this.adminFormGroup.controls).forEach(key => {
      // //   const control = this.adminFormGroup.get(key);
      // //   if (control) {
      // //     control.updateValueAndValidity();
      // //   }
      // // });

      // //　各フィールドにValidationRuleを適用
      // this.distributorAgentFormGroup.markAllAsTouched();
      // this.distributorAgentFormGroup.updateValueAndValidity({ onlySelf: false });
      // if (!this.distributorAgentFormGroup.valid) {
      //   let snack = this.snackBar.open(
      //     this.i18n.validation.checkFields,
      //     this.i18n.button.close,
      //     {
      //       duration: 30000,
      //     },
      //   );
      //   return;
      // 
    }

    //データベースにアップロードする

    var postParams: Record<string, any> = {};

    // postParams.userId = this.adminData.userId;
    postParams.distributorId = this.distributorId;

    // postParams.firstName =
    //   this.distributorAgentFormGroup.value.firstName != ""
    //     ? this.distributorAgentFormGroup.value.firstName
    //     : null;
    // postParams.lastName =
    //   this.distributorAgentFormGroup.value.lastName != ""
    //     ? this.distributorAgentFormGroup.value.lastName
    //     : null;

    // postParams.signInNames =
    //   this.distributorAgentFormGroup.value.signInName != ""
    //     ? this.distributorAgentFormGroup.value.signInName
    //     : null;
    // postParams.loginPassword =
    //   this.distributorAgentFormGroup.value.password != ""
    //     ? this.distributorAgentFormGroup.value.password
    //     : null;

    // postParams.birthDate =
    //   this.distributorAgentFormGroup.value.birthDate != ""
    //     ? this.distributorAgentFormGroup.value.birthDate
    //     : null;
    // postParams.sex =
    //   this.distributorAgentFormGroup.value.sex != ""
    //     ? this.distributorAgentFormGroup.value.sex
    //     : null;

    // postParams.status = this.distributorAgentFormGroup.value.status;

    postParams.adminType = "DISTRIBUTOR_AGENT";
    postParams.email = this.distributorAgentFormGroup.value.email;

    var roles = [];
    // this.common.sectionGroupAdminRoles.forEach(
    //   // 画面上で選択する権限
    //   (r) => {
    //     if (this.distributorAgentFormGroup.value[r.code]) {
    //       roles.push(r.code);
    //     }
    //   },
    // );
    // if (roles.length == 0) {
    //   let snack = this.snackBar.open(
    //     this.i18n.validation.selectAtLeastOneRole,
    //     this.i18n.button.close,
    //     {
    //       duration: 30000,
    //     },
    //   );
    //   return;
    // }

    // this.common.sectionGroupAdminRolesMustHave.forEach(
    //   // 画面上での選択とは別に常に付与する権限
    //   (r) => {
    //     roles.push(r.code);
    //   },
    // );
    postParams.roles = roles; // SectionGroupAdminUpdate では roles になっている
    postParams.role = roles; // MemberInvite では role になっている

    // if (this.mode == this.Mode.create) {
    //   if (
    //     this.distributorAgentFormGroup.value.password !=
    //     this.distributorAgentFormGroup.value.password_confirm
    //   ) {
    //     let snack = this.snackBar.open(
    //       this.i18n.validation.passwordMismatch,
    //       this.i18n.button.close,
    //       {
    //         duration: 30000,
    //       },
    //     );
    //     return;
    //   }
    // }

    // if (this.mode == SectionGroupAdminDetailMode.edit) {
    //   this.updateSectionGroupAdmin(postParams);
    // }

    // if (this.mode == SectionGroupAdminDetailMode.invite) {
      this.inviteDistributorAgent(postParams);
    // }

    // if (this.mode == SectionGroupAdminDetailMode.create) {
    //   this.createSectionGroupAdmin(postParams);
    // }
  }

  // updateSectionGroupAdmin(postParams) {
  //   this.updateSectionGroupAdminService
  //     .updateSectionGroupAdmin(
  //       this.adminData.sectionGroupId,
  //       this.adminData.userId,
  //       postParams,
  //     )
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe({
  //       next: (res) => {

  //         let snack = this.snackBar.open(
  //           this.i18n.message.updateSuccess,
  //           this.i18n.button.close,
  //           {
  //             duration: 30000,
  //           },
  //         );
  //         snack
  //           .afterDismissed()
  //           .pipe(takeUntilDestroyed(this.destroyRef))
  //           .subscribe(() => {
  //             this.dialogRef.close({ needRefresh: true });
  //             // this.router.navigate(['/section-group-admin/',this.sectionGroupId]).then(() => {
  //             //   this.router.navigate(['/section-group-admin/',this.sectionGroupId,  'admins']);
  //             // });
  //           });
  //       },
  //       error: (e) => {
  //         let snack = this.snackBar.open(
  //           this.i18n.message.updateError,
  //           this.i18n.button.close,
  //           {
  //             duration: 30000,
  //           },
  //         );
  //         snack
  //           .afterDismissed()
  //           .pipe(takeUntilDestroyed(this.destroyRef))
  //           .subscribe(() => {
  //             this.dialogRef.close();
  //           });
  //       },
  //     });
  // }

  inviteDistributorAgent(postParams) {
    this.inviteMembersService
      .inviteMembers(null, postParams)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {

          let snack = this.snackBar.open(
            this.i18n.message.inviteSuccess,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close();
              // this.router.navigate(['/section-group-admin/',this.sectionGroupId]).then(() => {
              //   this.router.navigate(['/section-group-admin/',this.sectionGroupId,  'admins']);
              // });
            });
        },
        error: (e) => {
          let snack = this.snackBar.open(
            this.i18n.message.inviteError,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
              this.dialogRef.close();
            });
        },
      });
  }

  // createSectionGroupAdmin(postParams) {
  //   postParams.createUser = true;
  //   postParams.homeUrl = window.location.href;

  //   this.createSectionGroupAdminService
  //     .createSectionGroupAdmin(this.sectionGroupId, postParams)
  //     .pipe(takeUntilDestroyed(this.destroyRef))
  //     .subscribe({
  //       next: (res) => {

  //         let snack = this.snackBar.open(
  //           this.i18n.message.createSuccess,
  //           this.i18n.button.close,
  //           {
  //             duration: 30000,
  //           },
  //         );
  //         snack
  //           .afterDismissed()
  //           .pipe(takeUntilDestroyed(this.destroyRef))
  //           .subscribe(() => {
  //             this.dialogRef.close({ needRefresh: true });
  //             // this.router.navigate(['/section-group-admin/',this.sectionGroupId]).then(() => {
  //             //   this.router.navigate(['/section-group-admin/',this.sectionGroupId,  'admins']);
  //             // });
  //           });
  //       },
  //       error: (e) => {
  //         let snack = this.snackBar.open(
  //           this.i18n.message.createError + Object.values(e.error.errorMessage),
  //           this.i18n.button.close,
  //           {
  //             duration: 60000,
  //           },
  //         );
  //         snack
  //           .afterDismissed()
  //           .pipe(takeUntilDestroyed(this.destroyRef))
  //           .subscribe(() => {
  //           });
  //       },
  //     });
  // }
}
